<template>
    <v-container fluid>
        <div v-if="!loading">
           <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`"/>
            </v-row>
            <v-divider color="black"/>
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col cols="5"></v-col>
                <v-divider vertical color="black" />
                <v-col cols="2" class="text-center"> {{'Purchasing habits' | localize }}</v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col cols="2" class="text-center"> {{'Purchasing preferences' | localize }}</v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col cols="3" class="text-center">{{'Brand importance' | localize }}</v-col>
            </v-row>
            <v-divider color="black" />
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    cols="1"
                    class="text-pre-wrap"
                    :class="item.style">
                    {{ `${item.title}` | localize }}
                </v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col v-for="i in habits"
                    :key="i"
                    class="text-center"
                    cols="1">
                    {{ `${i}` | localize }}
                </v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col v-for="i in preferences"
                    :key="i"
                    class="text-center"
                    cols="1">
                    {{ `${i}` | localize }}
                </v-col>
                <v-divider vertical color="black"></v-divider>
                <v-col v-for="i in brand_importance"
                    :key="i"
                    cols="1"
                    class="text-center">
                    {{ `${i}` | localize }}
                </v-col>
            </v-row>
            <v-divider color="black" />
            <div v-if="market_segments.length" >
                <!--segments tab-->
                <div v-for="segment in market_segments"
                    :key="segment.id">
                    <v-row  class="body-2 my-1" no-gutters>
                        <v-col cols="1" class="text-truncate text-left">{{ segment.segment?.name }}</v-col>
                        <v-col cols="1" class="text-right ">{{ localeNumber(segment.segment?.peak_size) }}</v-col>
                        <v-col cols="1" class="text-right">{{ localeNumber(segment.actual_size) }}</v-col>
                        <v-col cols="1" class="text-right">{{ segment.min_price }}</v-col>
                        <v-col cols="1" class="text-right pr-1">{{ segment.max_price }}</v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="1" class="text-center">{{ Math.round(segment.lowest_price * 100)  }}%</v-col>
                        <v-col cols="1" class="text-center">{{ Math.round(segment.best_quality * 100) }}%</v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="1" class="text-center">{{ Math.round(segment.on_line * 100) }}%</v-col>
                        <v-col cols="1" class="text-center">{{ Math.round(segment.off_line * 100) }}%</v-col>
                        <v-divider vertical></v-divider>
                        <v-col class="text-center">{{ Math.round(segment.brand_high * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.brand_somehow * 100) }}%</v-col>
                        <v-col class="text-center">{{ Math.round(segment.brand_not * 100) }}%</v-col>
                    </v-row>
                    <v-divider></v-divider>
                </div>
            </div>
            <v-row v-else class="mt-4"
                justify="center">
                there are no segments yet
            </v-row>
        </div>
        <v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row> 
    </v-container>
</template>
<script>

import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';

export default {
    data() {
        return {
            text: {
                en: 'This report provides an assessment of the market size and focuses on the purchasing preferences, habits, and price expectations of consumers within each market segment.',
                ro: 'Acest raport oferă o evaluare a dimensiunii pieței și se concentrează asupra preferințelor de cumpărare, obiceiurilor și așteptărilor legate de preț ale consumatorilor din fiecare segment de piață.',
                ru: 'В данном отчете представлена оценка объема рынка, а также подробно рассмотрены покупательские предпочтения, привычки и ценовые ожидания потребителей в каждом сегменте рынка.'
            },
            headers: [
                {title: 'Segment', style: 'text-left'}, 
                { title: 'Peak size', style: 'text-right'},
                { title: 'Actual size \n(last year)', style: 'text-right'},
                { title: 'Min price, $', style: 'text-right'},
                { title: 'Max price, $', style: 'text-right pr-1'},
            ],
            habits: ['lowest price', 'best quality'],
            preferences: ['on-line', 'off-line'],
            brand_importance: ['high', 'somehow', 'not important'], 
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        game() {
            return this.$store.getters.game
        },
        market_segments() {
            return this.$store.getters.market_segments;
        },
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        },
        
    },
    components: {
        Information, Loader
    },
}
</script>


		
